import { useState, useEffect, memo } from 'react';
import { useAuth } from "../../context/loginContext.js";
import axiosAWS from '../../api/configAxios.js';
import Cookie from "js-cookie";
import RoTbGes from './row_tb.js';
import ModalesInsertsData from './modales_insert.js';
import Swal from 'sweetalert2';



var select_registro = null;
var set_registroType = null;
var set_registroPass = null;
var array_data_gtableros_user = [];
var array_data_gtableros_tablero = [];

const GestionAdmin = () => {

    const { user } = useAuth();
    const [CargaUsuarios, setCargaUsuarios] = useState(false);
    const [RowsUsers, setRowsUsers] = useState([]);
    const [CargaRoles, setCargaRoles] = useState(false);
    const [RowsRoles, setRowsRoles] = useState([]);
    const [CargaTableros, setCargaTableros] = useState(false);
    const [RowsTableros, setRowsTableros] = useState([]);
    const [CargaGTableros, setCargaGTableros] = useState(false);
    const [RowsGTableros, setRowsGTableros] = useState([]);

    const [LoadDelete, setLoadDeleteo] = useState(false);

    const set_registroS = (data, type) => {
        select_registro = data;
        set_registroType = type;
    }

    const set_registroPaS = (data) => {
        set_registroPass = data;
    }

    const get_registroS = () => {
        return [select_registro, set_registroType];
    }

    const get_registroPaS = () => {
        return set_registroPass;
    }

    const get_array_data_gtableros_user = () => {
        return array_data_gtableros_user;
    }

    const get_array_data_gtabelros_tablero = () => {
        return array_data_gtableros_tablero;
    }



    const get_data_consulta = async (url, data) => {
        var result = null;
        try {
            const cookies = Cookie.get();
            var result_auth = null;

            result_auth = await axiosAWS.post(url, data, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                   //console.log("error 400");
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la el servidor");
                }
            });

            //console.log(result_auth);

            if (result_auth.status >= 200 || result_auth.status <= 299) {
                if (result_auth.data.hasOwnProperty("result")) {
                    if (result_auth.data.result !== null) {
                        result = result_auth.data.result;

                    } else {
                        alert("sin datos presentes");
                    }

                }

            } else {
                alert("usuario denegado");
            }

            return result;
        } catch (error) {

           //console.log("error servidorAWS");
            return "error";
        }
    }

    const get_users = async () => {
        setCargaUsuarios(true);
        RowsUsers.length = 0;
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_usuarios_all" });
        result_tbl = result_tbl[0]
        //console.log(result_tbl);

        if (result_tbl.length === 0) {
            //alert("Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar")
            setCargaUsuarios(false);
            return
        }

        const add_row = [...RowsUsers];
        var cont = 0;
        result_tbl.forEach(element => {
            add_row.push(<RoTbGes type={"usuarios"} datos={element} key={"rU-" + cont} set_registroS={set_registroS} set_registroPaS={set_registroPaS} get_gtableros_user={get_gtableros_filt_user} />);
            cont++;
        });
        setRowsUsers(add_row);
        setCargaUsuarios(false);


    }

    const get_rols = async () => {
        setCargaRoles(true);
        RowsRoles.length = 0;
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_roles_all" });
        result_tbl = result_tbl[0]
        //console.log(result_tbl);

        if (result_tbl.length === 0) {
            //alert("Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar");
            setCargaRoles(false);
            return
        }

        const add_row = [...RowsRoles];
        var cont = 0;
        result_tbl.forEach(element => {
            add_row.push(<RoTbGes type={"roles"} datos={element} key={"rR-" + cont} set_registroS={set_registroS} />);
            cont++;
        });
        setRowsRoles(add_row);
        setCargaRoles(false);
    }

    const get_tableros = async () => {
        setCargaTableros(true);
        RowsTableros.length = 0;
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_tableros_all" });
        result_tbl = result_tbl[0]
        //console.log(result_tbl);

        if (result_tbl.length === 0) {
            //alert("Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar")
            setCargaTableros(false);
            return
        }

        const add_row = [...RowsTableros];
        var cont = 0;
        result_tbl.forEach(element => {
            add_row.push(<RoTbGes type={"tableros"} datos={element} key={"rT-" + cont} set_registroS={set_registroS} get_gtableros_tablero={get_gtableros_filt_tablero} />);
            cont++;
        });
        setRowsTableros(add_row);
        setCargaTableros(false);


    }

    const get_Gtableros = async () => {
        setCargaGTableros(true);
        RowsGTableros.length = 0;
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_Gtableros_all" });
        result_tbl = result_tbl[0]
        //console.log(result_tbl);

        if (result_tbl.length === 0) {
            //alert("Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar")
            setCargaGTableros(false);
            return
        }

        const add_row = [...RowsGTableros];
        var cont = 0;
        result_tbl.forEach(element => {
            add_row.push(<RoTbGes type={"Gtableros"} datos={element} key={"rGT-" + cont} set_registroS={set_registroS} />);
            cont++;
        });
        setRowsGTableros(add_row);
        setCargaGTableros(false);


    }

    const get_gtableros_filt_user = async (_uuid) => {

        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_Gtableros_filt_user", uuid: _uuid });
        result_tbl = result_tbl[0];
       //console.log("gt_user");
       //console.log(result_tbl);

        if (result_tbl.length === 0) {
            //return null;
            //array_data_gtableros_user = []
            return [];
        }
        // return result_tbl;
        //array_data_gtableros_user = result_tbl;
        return result_tbl;
    }

    const get_gtableros_filt_tablero = async (_uuid) => {

       //console.log("uuid-tablero: ",_uuid);
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_Gtableros_filt_tablero", uuid: _uuid });
        result_tbl = result_tbl[0];
       //console.log("gt_tablero");
       //console.log(result_tbl);

        if (result_tbl.length === 0) {
            //return null;
            //array_data_gtableros_tablero = []
            return [];
        }
        // return result_tbl;
        return result_tbl;
        //array_data_gtableros_tablero = result_tbl;
    }



    ///

    ///delete
    const delete_element = async () => {
        setLoadDeleteo(true)

        document.getElementById("delete_element").innerHTML = "enviando...";
        document.getElementById("delete_element").disabled = true;

        var result_insert = await get_data_consulta("panel-control/delete-element", { type: set_registroType, uuid: select_registro });

       //console.log(result_insert)

        if (result_insert === "error") {

            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'Existio un error al intentar eliminar el registro',
                timer: 4000
            });

            //alert('existio un error al intentar eliminar el registro');
            document.getElementById("delete_element").innerHTML = "Eliminar";
            document.getElementById("delete_element").disabled = false;
            setLoadDeleteo(false);
            return
        }

        if (!result_insert.hasOwnProperty("affectedRows")) {

            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'Existio un error al intentar eliminar el registro',
                timer: 4000
            });

            //alert('existio un error al intentar eliminar el registro');
            document.getElementById("delete_element").innerHTML = "Eliminar";
            document.getElementById("delete_element").disabled = false;
            setLoadDeleteo(false);
            return
        }


        if (set_registroType === "user") {

            Swal.fire({
                icon: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Exito',
                text: 'Usuario elimiado',
                timer: 4000
            });

            //alert("usuario eliminado");
            get_users();
        }
        if (set_registroType === "rol") {
            Swal.fire({
                icon: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Exito',
                text: 'Rol elimiado',
                timer: 4000
            });
            //alert("rol eliminado");
            get_rols();
        }
        if (set_registroType === "tablero") {
            Swal.fire({
                icon: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Exito',
                text: 'Tablero elimiado',
                timer: 4000
            });
            //alert("tablero eliminado");
            get_tableros();
        }

        if (set_registroType === "gtablero") {
            Swal.fire({
                icon: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Exito',
                text: 'Grupo de tablero elimiado',
                timer: 4000
            });
            //alert("grupo tablero eliminado");
            get_Gtableros();
        }

        setLoadDeleteo(false);
        document.getElementById("delete_element").innerHTML = "Eliminar";
        document.getElementById("delete_element").disabled = false;
        document.getElementById("closeb6").click();

        //actualizamos los datos
        get_users();
        get_rols();
        get_tableros();
        get_Gtableros();

    }

    useEffect(() => {
        get_users();
        get_rols();
        get_tableros();
        get_Gtableros();
    }, [])

    //retornamos "la vista para el login"
    if (user !== null) {
        if (user.rol_titulo === "Administrador") {
            return (
                <div className='bg-dark-subtle h-100 pb-4'>
                    <div className="card-body p-5 pb-0">
                        <div className='mb-5'>
                            <label className='text-title-001'>Panel - <b className='text-body-tertiary'>Control </b></label>
                        </div>
                        {/** card bg-body-secondary */}

                    </div>

                    <div className='card-body p-3 h-100'>
                        <div className='col-12'>

                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="usuarios-tab" data-bs-toggle="tab" data-bs-target="#usuarios-tab-pane" type="button" role="tab" aria-controls="usuarios-tab-pane" aria-selected="true">Usuarios</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="roles-tab" data-bs-toggle="tab" data-bs-target="#roles-tab-pane" type="button" role="tab" aria-controls="roles-tab-pane" aria-selected="false">Roles</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="tableros-tab" data-bs-toggle="tab" data-bs-target="#tableros-tab-pane" type="button" role="tab" aria-controls="tableros-tab-pane" aria-selected="false">Tableros</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="Gtableros-tab" data-bs-toggle="tab" data-bs-target="#Gtableros-tab-pane" type="button" role="tab" aria-controls="Gtableros-tab-pane" aria-selected="false">Grupos de Tableros</button>
                                </li>

                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="usuarios-tab-pane" role="tabpanel" aria-labelledby="usuarios-tab" tabIndex={0}>
                                    <div className=' bg-body-secondary'>
                                        <div className='col-md-12 p-3 text-end'>
                                            <button className='btn btn-dark' data-bs-toggle="modal" data-bs-target="#m_usuariosI" aria-label="Close">Agregar</button>
                                        </div>
                                        {/**
             <label className="fs-6 text-center w-100"><b className='text-body-tertiary'>-- Filtros -- </b></label>
            <div className='row p-4'>
                <div className='col-md-3'>
                    <label>Estatus</label>
                    <select className='form-select'>
                        <option>.:Selecciona:.</option>
                        <option value={1}>Activo</option>
                        <option value={0}>Desactivado</option>
                    </select>
                </div>
                <div className='col-md-3'>
                    <label>Grupo</label>
                    <select className='form-select'>
                        <option>.:Selecciona:.</option>
                    </select>
                </div>
                <div className='col-md-3 '>
                    <button className='btn btn-outline-dark mt-4'><i className="bi bi-search"></i> Buscar</button>
                </div>
            </div>
             */}


                                        <div className='m-2 pb-1'>
                                            <div className="table-responsive">
                                                <table className="table text-center">
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th scope="col">E-mail</th>
                                                            <th scope="col">Estatus</th>
                                                            <th scope="col">Nombre</th>
                                                            <th scope="col">Cargo</th>
                                                            <th scope="col">Grupos de Tableros</th>
                                                            <th scope="col">Opciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            !CargaUsuarios ?
                                                                RowsUsers.length !== 0 ?
                                                                    RowsUsers.map((item, index) => {

                                                                        return (
                                                                            item
                                                                        );


                                                                    })
                                                                    :
                                                                    <td scope="col" colSpan={6}>
                                                                        <div className="text-center bg-transparent">
                                                                            <img src="./img/darse-de-baja.png" width={"80px"} /><br></br>
                                                                            Sin registros...
                                                                        </div>

                                                                    </td>
                                                                :
                                                                <td scope="col" colSpan={6}>
                                                                    <div className="text-center">
                                                                        <img src="./img/progress-unscreen.gif" width={"80px"} /><br></br>
                                                                        Cargando...
                                                                    </div>

                                                                </td>

                                                        }
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="roles-tab-pane" role="tabpanel" aria-labelledby="roles-tab" tabIndex={0}>
                                    <div className=' bg-body-secondary'>
                                        <div className='col-md-12 p-3 text-end'>
                                            <button className='btn btn-dark' data-bs-toggle="modal" data-bs-target="#m_rolesI" aria-label="Close">Agregar</button>
                                        </div>

                                        <div className='m-2 pb-1'>
                                            <div className="table-responsive">
                                                <table className="table text-center">
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th scope="col">Cargo</th>
                                                            <th scope="col">Opciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            !CargaRoles ?
                                                                RowsRoles.length !== 0 ?
                                                                    RowsRoles.map((item, index) => {

                                                                        return (
                                                                            item
                                                                        );


                                                                    })
                                                                    :
                                                                    <td scope="col" colSpan={2}>
                                                                        <div className="text-center bg-transparent">
                                                                            <img src="./img/darse-de-baja.png" width={"80px"} /><br></br>
                                                                            Sin registros...
                                                                        </div>

                                                                    </td>
                                                                :
                                                                <td scope="col" colSpan={2}>
                                                                    <div className="text-center">
                                                                        <img src="./img/progress-unscreen.gif" width={"80px"} /><br></br>
                                                                        Cargando...
                                                                    </div>

                                                                </td>

                                                        }
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                                <div className="tab-pane fade" id="tableros-tab-pane" role="tabpanel" aria-labelledby="tableros-tab" tabIndex={0}>
                                    <div className=' bg-body-secondary'>
                                        <div className='col-md-12 p-3 text-end'>
                                            <button className='btn btn-dark' data-bs-toggle="modal" data-bs-target="#m_tableroI" aria-label="Close">Agregar</button>
                                        </div>

                                        <div className='m-2 pb-1'>
                                            <div className="table-responsive">
                                                <table className="table text-center">
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th scope="col">Titulo</th>
                                                            <th scope="col">Estatus</th>
                                                            <th scope="col">Grupo Tablero</th>
                                                            <th scope="col" style={{width: "300px"}}>URL</th>
                                                            <th scope="col">Descripción</th>
                                                            <th scope="col">Opciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            !CargaTableros ?
                                                                RowsTableros.length !== 0 ?
                                                                    RowsTableros.map((item, index) => {

                                                                        return (
                                                                            item
                                                                        );


                                                                    })
                                                                    :
                                                                    <td scope="col" colSpan={6}>
                                                                        <div className="text-center bg-transparent">
                                                                            <img src="./img/darse-de-baja.png" width={"80px"} /><br></br>
                                                                            Sin registros...
                                                                        </div>

                                                                    </td>
                                                                :
                                                                <td scope="col" colSpan={6}>
                                                                    <div className="text-center">
                                                                        <img src="./img/progress-unscreen.gif" width={"80px"} /><br></br>
                                                                        Cargando...
                                                                    </div>

                                                                </td>

                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>

                                    </div>


                                </div>
                                <div className="tab-pane fade" id="Gtableros-tab-pane" role="tabpanel" aria-labelledby="Gtableros-tab" tabIndex={0}>
                                    <div className=' bg-body-secondary'>
                                        <div className='col-md-12 p-3 text-end'>
                                            <button className='btn btn-dark' data-bs-toggle="modal" data-bs-target="#m_GTablerosI" aria-label="Close">Agregar</button>
                                        </div>
                                        <div className='m-2 pb-1'>
                                            <div className="table-responsive">
                                                <table className="table text-center">
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th scope="col">Titulo</th>
                                                            <th scope="col">Estatus</th>
                                                            <th scope="col">Descripción</th>
                                                            <th scope="col">Opciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            !CargaGTableros ?
                                                                RowsGTableros.length !== 0 ?
                                                                    RowsGTableros.map((item, index) => {

                                                                        return (
                                                                            item
                                                                        );


                                                                    })
                                                                    :
                                                                    <td scope="col" colSpan={4}>
                                                                        <div className="text-center bg-transparent">
                                                                            <img src="./img/darse-de-baja.png" width={"80px"} /><br></br>
                                                                            Sin registros...
                                                                        </div>

                                                                    </td>
                                                                :
                                                                <td scope="col" colSpan={4}>
                                                                    <div className="text-center">
                                                                        <img src="./img/progress-unscreen.gif" width={"80px"} /><br></br>
                                                                        Cargando...
                                                                    </div>

                                                                </td>

                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <ModalesInsertsData
                        get_users={get_users}
                        get_rols={get_rols}
                        get_tableros={get_tableros}
                        get_Gtableros={get_Gtableros}
                        delete_element={delete_element}
                        get_registroPaS={get_registroPaS}
                        get_registroS={get_registroS}
                        get_gtableros_filt_user={get_gtableros_filt_user}
                        get_gtableros_filt_tablero={get_gtableros_filt_tablero}
                    />
                </div>

            );
        } else {
            return (
                <>
                    <div className='mb-5'>
                        <label className='text-title-001'>Sin - <b className='text-body-tertiary'>Acesso </b></label>
                    </div>
                </>
            );
        }
    } else {
        return (
            <>
                <div className='mb-5 text-center'>
                    <label className='text-title-001'>Sin - <b className='text-body-tertiary'>Acesso </b></label>
                </div>
            </>
        );
    }

}

export default memo(GestionAdmin);

